import { NavigationSubItem } from "../navigation-item"

export class DesignPaletteSubItem extends NavigationSubItem {
  readonly id = "design-palette"
  readonly label = "Design Palette"
  readonly href = "/design/design-palette"
  readonly iconName = "design-palette-icon"
  readonly isExternal = false
  readonly tabs = []
}
